<div class="content">
  @if (currentState === CookieManagementState.Initial) {
  <div class="flex-center ion-padding-horizontal">
    <p>{{ 'cookies.first_body' | translate }}</p>
  </div>
  } @if (currentState === CookieManagementState.Managing) {
  <ion-grid class="ion-padding">
    <ion-row class="ion-margin-bottom">
      <div>
        <ion-item lines="none">
          <ion-checkbox checked="true" disabled="true">{{
            'cookies.needed_title' | translate
          }}</ion-checkbox>
        </ion-item>
        <p class="ion-no-margin ion-padding-start">
          {{ 'cookies.needed_body' | translate }}
        </p>
      </div>
    </ion-row>
    <ion-row>
      <div>
        <ion-item lines="none">
          <ion-checkbox (ionChange)="checkBoxChanged($event)" checked="false">{{
            'cookies.analytics_title' | translate
          }}</ion-checkbox>
        </ion-item>
        <p class="ion-no-margin ion-padding-start">
          {{ 'cookies.analytics_body' | translate }}
        </p>
      </div>
    </ion-row>
  </ion-grid>
  }
</div>

@if (currentState === CookieManagementState.Initial) {
<ion-footer>
  <ion-grid>
    <ion-row>
      <ion-col size="6">
        <ion-button
          color="primary"
          (click)="updateFixedValue()"
          color="dark"
          fill="outline"
          expand="block"
          shape="round"
        >
          {{ 'cookies.modal_title' | translate }}
        </ion-button>
      </ion-col>
      <ion-col size="6">
        <ion-button
          color="primary"
          (click)="acceptAll()"
          color="primary"
          expand="block"
          shape="round"
        >
          {{ 'cookies.accept_all_btn' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
} @if (currentState === CookieManagementState.Managing) {
<ion-footer>
  <ion-grid>
    <ion-item lines="none">
      {{ 'cookies.accept_body' | translate }}
    </ion-item>
    <ion-row>
      <ion-col>
        <ion-button
          color="primary"
          (click)="checkAnalyticsAndClose()"
          color="primary"
          expand="block"
          shape="round"
        >
          {{ 'cookies.accept_btn' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
}
